module.exports = __webpack_public_path__ + "static/odd-one-out-cover-cd6e425c4ca97b24a2c935cae10bb01d.jpg";